import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ObjectApiInterface } from '../base/interfaces/object-api.interface';
import { environment } from '../../../environments/environment';

/**
 * Service pour l'import des utilisateurs test sur TOUS les tenants
 * Utilise l'endpoint CORE (pas besoin de tenant spécifique)
 */
@Injectable({
  providedIn: 'root',
})
export class UserTestImportService {
  private baseUrlApi = `${environment.API_URL}/user`;

  constructor(private http: HttpClient) {}

  /**
   * Import des utilisateurs test sur TOUS les tenants (asynchrone)
   * L'import se fait en tâche de fond via Worker
   * Supprime et recrée les utilisateurs test dans tous les tenants
   */
  importUsersTestToAllTenants(data: any): Observable<ObjectApiInterface<any>> {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/import-users-test-all-tenants`, data, {
      headers: { 'Error-CRUD': 'IMPORT' },
    });
  }

  /**
   * Télécharger le template Excel pour l'import
   */
  downloadUsersTestTemplate(): Observable<ObjectApiInterface<any>> {
    return this.http.get<ObjectApiInterface<any>>(`${environment.API_URL}/userProfile/downloadUsersTestTemplate`);
  }
}
